import React, { Component } from 'react';
import Track from 'track/Track.js';
import {getPagination} from 'components/pianoroll/PianoRollPagination.js';
import { connect } from "react-redux";
import {getCurrentPage} from 'components/pianoroll/PianoRollPagination.js';
import {getTotalPages} from 'components/pianoroll/PianoRollPagination.js';
import {hasNextPage} from 'components/pianoroll/PianoRollPagination.js';
import {setPianoRollPagination} from 'actions/index.js';
import {hasPreviousPage} from 'components/pianoroll/PianoRollPagination.js';
import {getNextPageStart} from 'components/pianoroll/PianoRollPagination.js';
import {getNextPageEnd} from 'components/pianoroll/PianoRollPagination.js';
import {getPreviousPageStart} from 'components/pianoroll/PianoRollPagination.js';
import {getPreviousPageEnd} from 'components/pianoroll/PianoRollPagination.js';

class PaginationButtons extends Component {
    getStart() {
        return this.props.paginationStart !== undefined ? this.props.paginationStart : this.props.start;
    }

    getEnd() {
        return this.props.paginationEnd !== undefined ? this.props.paginationEnd : this.props.end;
    }

    onClickPreviousPage() {
        this.props.setPianoRollPagination(getPreviousPageStart(this.getStart()),
                                          getPreviousPageEnd(this.getEnd()));
    }

    onClickNextPage() {
        this.props.setPianoRollPagination(getNextPageStart(this.getStart()),
                                          getNextPageEnd(this.getEnd()));
    }

    onClickUnlock() {
        this.props.setPianoRollPagination(undefined, undefined);
    }

    render() {
        return (
             <div className="pagination-buttons">
                <div className="page-info">{getCurrentPage(this.getStart())} / {getTotalPages(this.props.stepsLength)}</div>
                {this.props.paginationStart !== undefined ?
                    <div
                      className="unlock-button"
                      onClick={() => this.onClickUnlock()}>UNLOCK</div> : ''}
                {hasPreviousPage(this.getStart()) ?
                  <div
                    onClick={() => this.onClickPreviousPage()}
                    className="previous-page-button">
                    PREVIOUS
                  </div> : ''}
                {hasNextPage(this.getEnd(), this.props.stepsLength) ?
                  <div
                    onClick={() => this.onClickNextPage()}
                    className="next-page-button">
                    NEXT
                  </div>
                  : ''}
                 </div>
        );
    }
}
const mapStateToProps = (state, props) => {
    let steps = state.tracks.trackSteps[props.track.trackNumber];
    let id = props.sequencerEngine.getSequenceId();
    var currentStep = Math.floor(
        (state.sequencer.currentStep[id] || 0) /
            (Track.baseResolution.numSteps() /
             state.sequencer.resolution.numSteps()));
    currentStep = steps === undefined ? 0 : currentStep % steps.length;
    // based on the current step

    let pagination = steps === undefined ? 0 : getPagination(currentStep, steps.length);

    return {
        stepsLength: steps==undefined ? 16 : steps.length,
        paginationStart: state.keyboard.pianoRollPagination === undefined ? undefined : state.keyboard.pianoRollPagination.start,
        paginationEnd: state.keyboard.pianoRollPagination === undefined ? undefined : state.keyboard.pianoRollPagination.end,
        start: pagination.start,
        end: pagination.end,
    }
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setPianoRollPagination: (start, end) => dispatch(setPianoRollPagination(start, end)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(PaginationButtons);
